module.exports = __webpack_public_path__ + "static/media/standard_vtol.7987ca68.avif";